import { ErrorMessage, Field, useFormikContext } from "formik";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import DatePickerWithIcon from "../../pages/DatePickerWithIcon";
import { useEffect, useState } from "react";
import _ from "lodash";
import { t } from "i18next";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { postWorkshopTimezone } from "../../redux/groupWorkshop/actions";
import { SessionKeys } from "../../utils/AppUtils";
import Select from "react-select";
import { getLanguages } from "../../redux/user/actions";

const SessionCardForm = (props) => {

  const {
    session, index,
    isTimezoneListLoading, timezoneList, 
    isLanguageListLoading, languageList, sessionOnlyUpdate
  } = props;

  const {
    setFieldValue, setFieldTouched,
    values,
    handleChange, handleBlur, errors, touched
  } = useFormikContext();

  const dispatch = useDispatch();

  const groupWorkshopTimezone = useSelector(
    (state) => state.groupworkshop.groupWorkshopTimezone
  );
  

  const [weekDays,] = useState([
    { day: "Monday", id: "1" },
    { day: "Tuesday", id: "2" },
    { day: "Wednesday", id: "3" },
    { day: "Thursday", id: "4" },
    { day: "Friday", id: "5" },
    { day: "Saturday", id: "6" },
    { day: "Sunday", id: "7" },
  ]);

  useEffect(() => {
    // Check if sessionArray is not empty
    if (!_.isEmpty(session)) {
      if (session.sessionStartDate && session.sessionStartTime) {
        const dateM = moment(session.sessionStartDate).format("DD-MM-YYYY");
        const dateTimeM = moment(`${dateM} ${session.sessionStartTime}`, "DD-MM-YYYY HH:mm");
        setFieldValue(`sessionArray[${index}].sessionStartDateTime`, dateTimeM.format("YYYY-MM-DD HH:mm"));
      }
      if (session.sessionEndDate && session.sessionEndTime) {
        const dateM = moment(session.sessionEndDate).format("DD-MM-YYYY");
        const dateTimeM = moment(`${dateM} ${session.sessionEndTime}`, "DD-MM-YYYY HH:mm");
        setFieldValue(`sessionArray[${index}].sessionEndDateTime`, dateTimeM.format("YYYY-MM-DD HH:mm"));
      }
    }
  }, [session])

  useEffect(() => {
    if (values.sessionType === "recurring" && values.frequency === "weekly") {
      setFieldValue("nestedDaily", "")
      // setFieldValue("rangeofoccurence", "")
    } else if (values.sessionType === "recurring" && values.frequency === "daily") {
      // setFieldValue("nestedDaily", "everyday")
      setFieldValue("recurOn", "")
      // setFieldValue("rangeofoccurence", "")
    } else if (values.sessionType === "recurring" && values.frequency === "monthly") {
      setFieldValue("nestedDaily", "")
      // setFieldValue("nestedMonthly", "1")
      setFieldValue("recurOn", "")
      // setFieldValue("rangeofoccurence", "")
    }

    if (values.sessionType === "single" && session.sessionStartDate) {
      setFieldValue(`sessionArray[${index}].sessionEndDate`, session.sessionStartDate)
    }
  }, [values])

  return (
    <div className="row g-3">
      {/* {values.sessionType} */}
      {/* Session Name */}
      <Field
        name={`sessionArray[${index}].sessionId`}
        type="hidden"
      />
      {sessionOnlyUpdate && session.isKickoffSession ? "" : 
      <div className="col-md-12">
        <label
          name={`sessionArray[${index}].sessionName`}
          className="form-label"
        >
          {t("Session Name")}
          <sup className="text-danger">*</sup>
        </label>
        <Field
          name={`sessionArray[${index}].sessionName`}
          type="text"
          className={`form-control ${errors.sessionArray?.[index]?.sessionName &&
            touched.sessionArray?.[index]?.sessionName
            ? "is-invalid"
            : ""
            }`}
          placeholder={t("enterSessionName")}
          // onKeyPress={(e) => {
          //   const regex = /^[A-Za-z0-9\s]*$/; // Allow only alphabets, numbers, and spaces
          //   if (!regex.test(e.key)) {
          //     e.preventDefault(); // Prevent invalid input
          //   }
          // }}
          onChange={handleChange}
          onBlur={handleBlur}
          values={session.sessionName}
        // value={session.sessionName}
        />
        <ErrorMessage
          name={`sessionArray[${index}].sessionName`}
          component="div"
          className="invalid-feedback"
        />
      </div>}

      {/* Timezone */}
      <div className="col-md-6">
        <label
          htmlFor={`sessionArray[${index}].sessionTimezone`}
          className="form-label"
        >
          {t("timezone")}
          <sup className="text-danger">*</sup>
        </label>
        {/* <Field
          type="text"
          name={`sessionArray[${index}].sessionTimezone`}
          id={`sessionTimezone-${index}`}
          className="form-control"
          placeholder={t("timezone")}
          value={session.sessionTimezone}
          // value={session.sessionTimezone}
        /> */}
        <Select
          isMulti={false}
          name={`sessionArray[${index}].sessionTimezone`}
          className={`basic-multi-select w-100 multi-label-select form-control 
            ${errors?.sessionArray?.[index]?.sessionTimezone &&
              touched?.sessionArray?.[index]?.sessionTimezone
              ? "is-invalid"
              : ""
            }
          `}
          classNamePrefix="xsel"
          options={timezoneList}
          isLoading={isTimezoneListLoading}
          value={timezoneList.filter((timezone) => {
            return timezone.value === values.sessionArray[index].sessionTimezone
          })}
          onChange={(e) => {
            setFieldValue(`sessionArray[${index}].sessionTimezone`, e.value)
            setFieldTouched(`sessionArray[${index}].sessionTimezone`, true)
          }}
        />
        <ErrorMessage
          name={`sessionArray[${index}].sessionTimezone`}
          component="div"
          className="invalid-feedback"
        />
      </div>

      {/* Language */}
      <div className="col-md-6">
        <label
          htmlFor={`sessionArray[${index}].sessionLanguage`}
          className="form-label"
        >
          {t("language")}
          <sup className="text-danger">*</sup>
        </label>
        <Select
          isMulti={false}
          name={`sessionArray[${index}].sessionLanguage`}
          className={`basic-multi-select w-100 multi-label-select form-control 
            ${errors?.sessionArray?.[index]?.sessionTimezone &&
              touched?.sessionArray?.[index]?.sessionTimezone
              ? "is-invalid"
              : ""
            }
          `}
          classNamePrefix="xsel"
          options={languageList}
          isLoading={isLanguageListLoading}
          value={languageList.filter(lang => {
            return lang.value == values.sessionArray[index].sessionLanguage
          })}
          onChange={(e) => {
            setFieldValue(`sessionArray[${index}].sessionLanguage`, e.value)
            setFieldTouched(`sessionArray[${index}].sessionLanguage`, true)
          }}
        // isDisabled={!isEdit}
        />
        <ErrorMessage
          name={`sessionArray[${index}].sessionLanguage`}
          component="div"
          className="invalid-feedback"
        />
      </div>

      {/* Start Date */}
      <div className="col-md-6">
        <label
          htmlFor={`sessionStartDate-${index}`}
          className="form-label"
        >
          {t("startDate")}
          <sup className="text-danger">*</sup>
        </label>
        <Field
          name={`sessionArray[${index}].sessionStartDate`}
          component={DatePickerWithIcon}
          type="text"
          className={`form-control ${errors.sessionArray?.[index]?.sessionStartDate &&
            touched.sessionArray?.[index]?.sessionStartDate
            ? "is-invalid"
            : ""
            }`}
          placeholder="DD-MM-YYYY"
          onChange={handleChange}
          onBlur={handleBlur}
          value={session.sessionStartDate ? moment(session.sessionStartDate).format('DD-MM-YYYY') : ""}
        // onChange={(date) => {
        //   const formattedDate =
        //     moment(date).format(
        //       "YYYY-MM-DD"
        //     );

        //   // Ensure sessionStartDate is an array
        //   const updatedDates = [
        //     ...(values.sessionStartDate ||
        //       []),
        //   ];

        //   // Update the index
        //   updatedDates[index] =
        //     formattedDate;

        //   // Set the updated array
        //   setFieldValue(
        //     "sessionStartDate",
        //     updatedDates
        //   );
        // }}
        />
        <ErrorMessage
          name={`sessionArray[${index}].sessionStartDate`}
          component="div"
          className="invalid-feedback"
        />
      </div>

      {/* End Date */}
      <div className="col-md-6">
        <label
          htmlFor={`sessionArray[${index}].sessionEndDate`}
          className="form-label"
        >
          {t("endDate")}
          <sup className="text-danger">*</sup>
        </label>
        <Field
          name={`sessionArray[${index}].sessionEndDate`}
          component={DatePickerWithIcon}
          className={`form-control ${errors.sessionArray?.[index]?.sessionEndDate &&
            touched.sessionArray?.[index]?.sessionEndDate
            ? "is-invalid"
            : ""
            }`}
          placeholder="DD-MM-YYYY"
          onChange={handleChange}
          onBlur={handleBlur}
          value={session.sessionEndDate ? moment(session.sessionEndDate).format('DD-MM-YYYY') : ""}
          disabled={values.sessionType === "single"}
        // onChange={(date) => {
        //   const formattedDate =
        //     moment(date).format(
        //       "YYYY-MM-DD"
        //     );

        //   // Ensure sessionEndDate is an array
        //   const updatedDates = [
        //     ...(values.sessionEndDate ||
        //       []),
        //   ];

        //   // Update the index
        //   updatedDates[index] =
        //     formattedDate;

        //   // Set the updated array
        //   setFieldValue(
        //     "sessionEndDate",
        //     updatedDates
        //   );
        // }}
        />
        <ErrorMessage
          name={`sessionArray[${index}].sessionEndDate`}
          component="div"
          className="invalid-feedback"
        />
      </div>

      {/* Start Time */}
      <div className="col-md-6">
        <label
          htmlFor={`sessionArray[${index}].sessionStartTime`}
          className="form-label"
        >
          {t("startTime")}
          <sup className="text-danger">*</sup>
        </label>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <TimePicker
            name="sessionArray[index].sessionStartTime"
            className={`form-control ${errors.sessionArray?.[index]?.sessionStartTime &&
              touched.sessionArray?.[index]?.sessionStartTime
              ? "is-invalid"
              : ""
              }`}
            placeholder="hh:mm A"
            value={session.sessionStartTime ? moment(session.sessionStartTime, 'HH:mm') : null}
            onChange={(timeValue) => {
              setFieldTouched(`sessionArray[${index}].sessionStartTime`, true);
              if (timeValue) {
                timeValue = moment(timeValue).format('HH:mm');
                setFieldValue(`sessionArray[${index}].sessionStartTime`, timeValue);
              } else {
                setFieldValue(`sessionArray[${index}].sessionStartTime`, "");
              }
            }}
            // inputFormat="hh:mm A"
            minutesStep={1}
            // minTime={moment()}
            renderInput={(params) => <TextField {...params} />}
          // onChange={handleChange}
          // onBlur={handleBlur}
          // value={session.sessionStartTime}
          />
        </LocalizationProvider>

        {/* <Field
          name={`sessionArray[${index}].sessionStartTime`}
          type="time"
          className={`form-control ${errors.sessionArray?.[index]?.sessionStartTime &&
            touched.sessionArray?.[index]?.sessionStartTime
            ? "is-invalid"
            : ""
            }`}
          placeholder="HH:mm"
          onChange={handleChange}
          onBlur={handleBlur}
          value={session.sessionStartTime}
        /> */}
        <ErrorMessage
          name={`sessionArray[${index}].sessionStartTime`}
          component="div"
          className="invalid-feedback"
        />
      </div>

      {/* End Time */}
      <div className="col-md-6">
        <label
          htmlFor={`sessionArray[${index}].sessionEndTime`}
          className="form-label"
        >
          {t("endTime")}
          <sup className="text-danger">*</sup>
        </label>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <TimePicker
            name="sessionArray[index].sessionEndTime"
            className={`form-control ${errors.sessionArray?.[index]?.sessionEndTime &&
              touched.sessionArray?.[index]?.sessionEndTime
              ? "is-invalid"
              : ""
              }`}
            placeholder="hh:mm AM/PM"
            value={session.sessionEndTime ? moment(session.sessionEndTime, 'HH:mm') : null}
            onChange={(timeValue) => {
              setFieldTouched(`sessionArray[${index}].sessionEndTime`, true);
              if (timeValue) {
                timeValue = moment(timeValue).format('HH:mm');
                setFieldValue(`sessionArray[${index}].sessionEndTime`, timeValue);
              } else {
                setFieldValue(`sessionArray[${index}].sessionEndTime`, "");
              }
            }}
            // inputFormat="hh:mm A"
            minutesStep={1}
            // minTime={moment()}
            renderInput={(params) => <TextField {...params} />}
          // onChange={handleChange}
          // onBlur={handleBlur}
          // value={session.sessionStartTime}
          />
        </LocalizationProvider>
        {/* <Field
          name={`sessionArray[${index}].sessionEndTime`}
          type="time"
          className={`form-control ${errors.sessionArray?.[index]?.sessionEndTime &&
            touched.sessionArray?.[index]?.sessionEndTime
            ? "is-invalid"
            : ""
            }`}
          placeholder="HH:mm"
          onChange={handleChange}
          onBlur={handleBlur}
          value={session.sessionEndTime}
        /> */}
        <ErrorMessage
          name={`sessionArray[${index}].sessionEndTime`}
          component="div"
          className="invalid-feedback"
        />
      </div>

      {/* Mode of Attandance */}      
      <div className="col-md-12">
            <label
              id="modeOfAttendance"
              htmlFor="modeOfAttendance"
              className="form-label"
            >
              {t("modeOfAttendance")}<sup className="text-danger">*</sup>
            </label>
            <div className="d-flex gap-3">
              <div className="form-check d-flex align-items-center gap-2">
                <Field
                  className="form-check-input wb"
                  type="radio"
                  name={`sessionArray[${index}].modeOfAttendance`}
                  id={`modeOfAttendanceOnline-${index}`}
                  value="online" // Automatically updates the Formik state
                />
                <label
                  className="form-check-label"
                  htmlFor={`modeOfAttendanceOnline-${index}`}
                >
                  {t("online")}
                </label>
              </div>
              <div className="form-check d-flex align-items-center gap-2">
                <Field
                  className="form-check-input wb"
                  type="radio"
                  name={`sessionArray[${index}].modeOfAttendance`}
                  id={`modeOfAttendanceOnsite-${index}`}
                  value="onsite" // Automatically updates the Formik state
                />
                <label
                  className="form-check-label"
                  htmlFor={`modeOfAttendanceOnsite-${index}`}
                >
                  {t("onsite")}
                </label>
              </div>
            </div>
          </div>



              {/* Show URL Field if modeOfAttendance is "online" */}
        {values?.sessionArray[index]?.modeOfAttendance === "online" && (
          <div className="col-md-12">
            <label
              htmlFor={`sessionArray[${index}].sessionURL`}
              className="form-label"
            >
              {t("URL")}
              <sup className="text-danger">*</sup>{" "}
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-disabled">
                    {t("InfoTextWillComehere")}
                  </Tooltip>
                }
              >
                <span className="d-inline-block">
                  <span className="info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                      <path
                        d="M8 0C3.83984 0 0.5 3.36914 0.5 7.5C0.5 11.6602 3.83984 15 8 15C12.1309 15 15.5 11.6602 15.5 7.5C15.5 3.36914 12.1309 0 8 0ZM8 13.5938C4.63086 13.5938 1.90625 10.8691 1.90625 7.5C1.90625 4.16016 4.63086 1.40625 8 1.40625C11.3398 1.40625 14.0938 4.16016 14.0938 7.5C14.0938 10.8691 11.3398 13.5938 8 13.5938ZM9.17188 9.8438H8.70312V7.26562C8.70312 6.88477 8.38086 6.5625 8 6.5625H7.0625C6.65234 6.5625 6.35938 6.88477 6.35938 7.26562C6.35938 7.67578 6.65234 7.96875 7.0625 7.96875H7.29688V9.8438H6.82812C6.41797 9.8438 6.125 10.166 6.125 10.5469C6.125 10.957 6.41797 11.25 6.82812 11.25H9.17188C9.55273 11.25 9.875 10.957 9.875 10.5469C9.875 10.166 9.55273 9.8438 9.17188 9.8438ZM8 5.625C8.49805 5.625 8.9375 5.21484 8.9375 4.6875C8.9375 4.18945 8.49805 3.75 8 3.75C7.47266 3.75 7.0625 4.18945 7.0625 4.6875C7.0625 5.21484 7.47266 5.625 8 5.625Z"
                        fill="#2D2D2D"
                      />
                    </svg>
                  </span>
                </span>
              </OverlayTrigger>
            </label>
            <Field
              name={`sessionArray[${index}].sessionURL`}
              type="text"
              placeholder={t("enterURL")}
              className={`form-control ${
                errors.sessionArray?.[index]?.sessionURL && touched.sessionArray?.[index]?.sessionURL
                  ? "is-invalid"
                  : ""
              }`}
              onChange={handleChange}
              onBlur={handleBlur}
              value={session.sessionURL}
              // onChange={(e) => {
              //   const updatedURLs = [
              //     ...values.sessionURL,
              //   ];
              //   updatedURLs[index] =
              //     e.target.value;
              //   setFieldValue(
              //     "sessionURL",
              //     updatedURLs
              //   );
              // }}
            />
            <ErrorMessage
              name={`sessionArray[${index}].sessionURL`}
              component="div"
              className="invalid-feedback"
            />
          </div>
        )}

        {/* Show Address Field if modeOfAttendance is "onsite" */}
        {values?.sessionArray[index]?.modeOfAttendance === "onsite" && (
          <div className="col-md-12">
            <label
              htmlFor={`sessionArray[${index}].sessionAddress`}
              className="form-label"
            >
              {t("Address")}
              <sup className="text-danger">*</sup>{" "}
              <OverlayTrigger
                overlay={
                  <Tooltip id="tooltip-disabled">
                    {t("InfoTextWillComehere")}
                  </Tooltip>
                }
              >
                <span className="d-inline-block">
                  <span className="info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                      <path
                        d="M8 0C3.83984 0 0.5 3.36914 0.5 7.5C0.5 11.6602 3.83984 15 8 15C12.1309 15 15.5 11.6602 15.5 7.5C15.5 3.36914 12.1309 0 8 0ZM8 13.5938C4.63086 13.5938 1.90625 10.8691 1.90625 7.5C1.90625 4.16016 4.63086 1.40625 8 1.40625C11.3398 1.40625 14.0938 4.16016 14.0938 7.5C14.0938 10.8691 11.3398 13.5938 8 13.5938ZM9.17188 9.8438H8.70312V7.26562C8.70312 6.88477 8.38086 6.5625 8 6.5625H7.0625C6.65234 6.5625 6.35938 6.88477 6.35938 7.26562C6.35938 7.67578 6.65234 7.96875 7.0625 7.96875H7.29688V9.8438H6.82812C6.41797 9.8438 6.125 10.166 6.125 10.5469C6.125 10.957 6.41797 11.25 6.82812 11.25H9.17188C9.55273 11.25 9.875 10.957 9.875 10.5469C9.875 10.166 9.55273 9.8438 9.17188 9.8438ZM8 5.625C8.49805 5.625 8.9375 5.21484 8.9375 4.6875C8.9375 4.18945 8.49805 3.75 8 3.75C7.47266 3.75 7.0625 4.18945 7.0625 4.6875C7.0625 5.21484 7.47266 5.625 8 5.625Z"
                        fill="#2D2D2D"
                      />
                    </svg>
                  </span>
                </span>
              </OverlayTrigger>
            </label>
            <Field
              as="textarea"
              name={`sessionArray[${index}].sessionAddress`}
              placeholder={t("enterAddress")}
              className={`form-control ${
                errors.sessionArray?.[index]?.sessionAddress && touched.sessionArray?.[index]?.sessionAddress
                  ? "is-invalid"
                  : ""
              }`}
              onChange={handleChange}              
              onBlur={handleBlur}
              value={session.sessionAddress}
            />
            <ErrorMessage
              name={`sessionArray[${index}].sessionAddress`}
              component="div"
              className="invalid-feedback"
            />
          </div>
        )}

      {/* Recurring Form */}
      {
        values.sessionType === "recurring" &&
        <>
          <div className="col-md-12 mt-3">
            <label htmlFor="" className="form-label">
              {t("recurrencePatternDaily")}{" "}
              <sup className="text-danger">*</sup>
            </label>

            <div className="d-flex gap-3">
              <div className="form-check d-flex align-items-center gap-2">
                <Field
                  type="radio"
                  name="frequency"
                  value="daily"
                  className="form-check-input wb"
                />
                <label
                  class="form-check-label"
                  for="Daily"
                >
                  {t("daily")}
                </label>
              </div>
              <div className="form-check d-flex align-items-center gap-2">
                <Field
                  type="radio"
                  name="frequency"
                  value="weekly"
                  className="form-check-input wb"
                />
                <label
                  class="form-check-label"
                  for="Weekly"
                >
                  {" "}
                  {t("weekly")}
                </label>
              </div>
              <div className="form-check d-flex align-items-center gap-2">
                <Field
                  type="radio"
                  name="frequency"
                  value="monthly"
                  className="form-check-input wb"
                />
                <label
                  class="form-check-label"
                  for="Monthly"
                >
                  {t("monthly")}
                </label>
              </div>
            </div>
            <hr />
            {/* Nested Block: Daily */}
            {values.frequency === "daily" && (
              <div className="d-flex gap-3">
                <div className="form-check d-flex align-items-center gap-2">
                  <Field
                    type="radio"
                    name="nestedDaily"
                    value="everyday"
                    className="form-check-input wb"
                  />
                  <label
                    class="form-check-label"
                    for="Everyday"
                  >
                    {t("everyday")}
                  </label>
                </div>
                <div className="form-check d-flex align-items-center gap-2">
                  <Field
                    type="radio"
                    name="nestedDaily"
                    value="every_weekday"
                    className="form-check-input wb"
                  />
                  <label
                    class="form-check-label"
                    for="every_weekday"
                  >
                    {" "}
                    {t("everyWeekday")}
                  </label>
                </div>
              </div>
            )}
            {values.frequency === "monthly" && (
              <div className="d-flex gap-3 flex-column">
                <div className="form-check d-flex align-items-center gap-2">
                  <Field
                    type="radio"
                    name="nestedMonthly"
                    value="1"
                    className="form-check-input wb"
                  />
                  <label
                    class="form-check-label"
                    for="Everyday"
                  >
                    {" "}
                    {t("day")}{" "}
                  </label>
                  <Field
                    type="number"
                    name="dayOfMonth"
                    min="1"
                    max="31"
                    // className="form-control fixdwe "
                    className={`form-control fixdwe ${errors.dayOfMonth &&
                      touched.dayOfMonth
                      ? "is-invalid"
                      : ""
                      }`}
                    disabled={
                      values.nestedMonthly !== "1" ||
                      values.frequency !== "monthly"
                    }
                  />

                  {" "}
                  {t("ofEveryMonth")}
                </div>
                <ErrorMessage
                  name="dayOfMonth"
                  component="div"
                  className="trainer_val text-danger"
                />
                <div className="form-check d-flex align-items-center gap-2">
                  <Field
                    type="radio"
                    name="nestedMonthly"
                    value="2"
                    // className="form-check-input wb"
                    className={`form-check-input wb ${errors.nestedMonthly &&
                      touched.nestedMonthly
                      ? "is-invalid"
                      : ""
                      }`}
                  />
                  <label
                    class="form-check-label"
                    for="Everyday"
                  >
                    {t("The")}{" "}
                  </label>
                  <Field
                    as="select"
                    name="firstSecondThird"
                    // className="form-select fixdwe"
                    className={`form-select fixdwe ${errors.firstSecondThird &&
                      touched.firstSecondThird
                      ? "is-invalid"
                      : ""
                      }`}
                    disabled={
                      values.nestedMonthly !== "2"
                    }
                  >
                    <option value="">{t("Select")}</option>
                    <option value="first">
                      {t("first")}
                    </option>
                    <option value="second">
                      {t("second")}
                    </option>
                    <option value="third">
                      {t("third")}
                    </option>
                    <option value="fourth">
                      {t("fourth")}
                    </option>{" "}
                    <option value="last">
                      {t("last")}
                    </option>{" "}
                    {/* Added Fourth */}
                  </Field>{" "}
                  <Field
                    as="select"
                    name="dayWeekdayWeekend"
                    // className="form-select fixdwe2"
                    className={`form-select fixdwe2 ${errors.firstSecondThird &&
                      touched.firstSecondThird
                      ? "is-invalid"
                      : ""
                      }`}
                    disabled={
                      values.nestedMonthly !== "2"
                    }
                  >
                    <option value="">{t("Select")}</option>
                    {
                      weekDays.map((weekday) => (
                        <option key={weekday.day} value={weekday.day.toLocaleLowerCase()}>
                          {weekday.day}
                        </option>
                      ))
                    }
                    {/* <option value="sunday">
                      Sunday
                    </option>
                    <option value="monday">
                      Monday
                    </option>
                    <option value="tuesday">
                      Tuesday
                    </option>
                    <option value="wednesday">
                      Wednesday
                    </option>
                    <option value="thursday">
                      Thursday
                    </option>
                    <option value="friday">
                      Friday
                    </option>
                    <option value="Saturday">
                      Saturday
                    </option> */}
                  </Field>{" "}
                  {t("ofEvery")}{" "}
                  <Field
                    type="number"
                    name="monthName"
                    // className="form-control fixdwe"
                    className={`form-control fixdwe ${errors.monthName &&
                      touched.monthName
                      ? "is-invalid"
                      : ""
                      }`}
                    disabled={
                      values.nestedMonthly !== "2"
                    }
                  // onChange={(e) => {
                  //   const value = e.target.value;
                  //   if (
                  //     value === "" ||
                  //     (value >= 1 && value <= 12)
                  //   ) {
                  //     setFieldValue(
                  //       "monthName",
                  //       value
                  //     );
                  //   }
                  // }}
                  />
                  <sup className="text-danger">*</sup>{" "}
                  {t("month(s)")}
                </div>

                <ErrorMessage
                  name="dayWeekdayWeekend"
                  component="div"
                  className="trainer_val text-danger"
                />
                <ErrorMessage
                  name="firstSecondThird"
                  component="div"
                  className="trainer_val text-danger"
                />
                <ErrorMessage
                  name="nestedMonthly"
                  component="div"
                  className="trainer_val text-danger"
                />
                <ErrorMessage
                  name="monthName"
                  component="div"
                  className="trainer_val text-danger"
                />
              </div>
            )}

            {/* Weekly Recurrence */}
            {values.frequency === "weekly" && (
              <div className="filter-section">
                <label
                  htmlFor="recurOn"
                  className="form-label"
                >
                  {t("recurOn")}<sup className="text-danger">*</sup>
                </label>
                <div className="d-flex gap-2 customcheck-row flex-wrap">
                  {weekDays.map((weekday, index) => (
                    <div
                      className="form-check customcheck m-0"
                      key={index}
                    >
                      <Field
                        type="checkbox"
                        name="recurOn"
                        value={weekday.id}
                        className="form-check-input"
                      />
                      <label className="form-check-label">
                        {weekday.day}
                      </label>
                    </div>
                  ))}
                </div>
                <ErrorMessage
                  name="recurOn"
                  component="div"
                  className="trainer_val text-danger"
                />
              </div>
            )}
          </div>
          <div className="col-md-12 mt-3">
            <label
              htmlFor="rangeofoccurence"
              className="form-label"
            >
              {t("rangeOfRecurrence")}
              <span>({t("endAfterOccurrences")})</span>
              {/* <sup className="text-danger">*</sup> */}
            </label>
            <Field
              name="rangeofoccurence"
              type="number"
              className={`form-control ${errors.rangeofoccurence &&
                touched.rangeofoccurence
                ? "is-invalid"
                : ""
                }`}
              placeholder={t("enterRange")}
              onChange={(e) => {
                const value = e.target.value;
                if (
                  value === "" ||
                  (value >= 0)
                ) {
                  setFieldValue(
                    "rangeofoccurence",
                    value
                  );
                }
              }}
            />
            <ErrorMessage
              name="rangeofoccurence"
              component="div"
              className="invalid-feedback"
            />
          </div>
        </>
      }
    </div>
  )
}

export default SessionCardForm;